<template>
   <div style="height:100%;width:100%;" class="content-box">
       <!-- 系统管理 -->
        
   </div>
</template>

<script>
   export default {
       name:'',
       data(){
           return {

           }
       },
       mounted(){},

       methods: {}
   }
</script>

<style lang='less' scoped>
.content-box{
    // background:url("~@/assets/1.svg") center center no-repeat;
    img{width:100%;}
}
</style>



// WEBPACK FOOTER //
// src/view/system/system.vue